import { formatVersionBarLabel, normalizeVersionBarState } from "@components/PayRangeVersionBar/payRangeVersionBarUtils";
import { layoutRecordRows } from "@components/EmployeeTimeline/employeeTimelineLayout";
import { toIso, toTime } from "@components/Timeline/timelineDateUtils";

/** PeriodBar state for a pay-range version row. */
export function versionToPeriodBarState(rawState) {
  return normalizeVersionBarState(rawState);
}

export function normalizeVersionNumber(value) {
  const parsed = Number(String(value ?? "").replace(/^v/i, ""));
  return Number.isFinite(parsed) ? parsed : value;
}

export function normalizeVersionRow(raw) {
  return {
    version: normalizeVersionNumber(raw.version),
    state: normalizeVersionBarState(raw.state ?? raw.status),
    bottom: raw.bottom ?? raw.minAmount ?? null,
    top: raw.top ?? raw.maxAmount ?? null,
    effectiveFrom: raw.effectiveFrom ?? raw.startDate ?? null,
    effectiveTo: raw.effectiveTo ?? raw.endDate ?? null,
    retired: Boolean(raw.retired),
  };
}

/**
 * Build layout records for the shared timeline row packer, including
 * backdated hand-off clipping on the current version (PRT-specific).
 */
export function buildVersionLayoutRows(
  versions,
  {
    currencySymbol,
    todayMs,
    handoffMs,
    windowStartMs,
    windowEndMs,
    trackWidthPx,
  }
) {
  const sorted = [...versions]
    .map(normalizeVersionRow)
    .sort((a, b) => (toTime(a.effectiveFrom) ?? 0) - (toTime(b.effectiveFrom) ?? 0));

  const records = sorted.map((v) => {
    let effectiveTo = v.effectiveTo;
    if (
      v.state === "current" &&
      handoffMs != null &&
      todayMs != null &&
      handoffMs <= todayMs &&
      (effectiveTo == null || effectiveTo === "")
    ) {
      effectiveTo = toIso(new Date(handoffMs));
    }

    return {
      id: v.version,
      label: formatVersionBarLabel(v.version, v.bottom, v.top, currencySymbol),
      state: versionToPeriodBarState(v.state),
      effectiveFrom: v.effectiveFrom,
      effectiveTo,
      workflowState: v.retired ? "Retired" : "",
      meta: v,
    };
  });

  return layoutRecordRows(
    records,
    windowStartMs,
    windowEndMs,
    trackWidthPx,
    todayMs
  );
}

export const LEGEND_ITEMS = [
  { versionState: "lapsed", swatch: "lapsed", label: "Lapsed" },
  { versionState: "current", swatch: "current", label: "Current" },
  { versionState: "future", swatch: "future", label: "Future" },
  { versionState: "draft", swatch: "draft", label: "Proposed" },
];
